import React, { useEffect, useRef, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const services = [
  { id: 1, name: "3D Box Letters" },
  { id: 2, name: "Channel Letter" },
  { id: 3, name: "ACP Board" },
  { id: 4, name: "Glow Sign Board" },
  { id: 5, name: "Neon Signage" },
  { id: 6, name: "LED Panels" },
  { id: 7, name: "Video Panel" },
  { id: 8, name: "Fabric Board" },
];

function useInquiryReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);
  return [ref, visible];
}

function Reveal({ children, delayMs = 0, visible, className = "" }) {
  return (
    <div
      className={[
        visible ? "animate-fade-up motion-reduce:animate-none motion-reduce:opacity-100" : "opacity-0",
        className,
      ].join(" ")}
      style={{ animationDelay: visible ? `${delayMs}ms` : undefined }}
    >
      {children}
    </div>
  );
}

function Inquiry() {
  const [inquiryRef, visible] = useInquiryReveal();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for form submission logic (e.g., send to API, WhatsApp, email)
    console.log("Form submitted");
  };

  return (
    <section
      ref={inquiryRef}
      className="relative min-h-screen flex items-center overflow-hidden bg-surface text-white py-16 lg:py-20"
    >
      <div className="absolute inset-0 bg-gradient-hero-glow" aria-hidden />
      <div
        className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,10,10,0.3)_0%,#0a0a0a_100%)]"
        aria-hidden
      />
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto">


          <Reveal visible={visible} delayMs={400}>
            <div
              className={[
"border-gradient-brand rounded-2xl bg-surface-elevated/90 backdrop-blur-md p-5 md:p-7 shadow-brand-glow lg:hover:shadow-[0_0_50px_-8px_rgba(234,88,12,0.35)] transition-shadow duration-500",
                visible ? "animate-scale-in motion-reduce:animate-none motion-reduce:opacity-100 motion-reduce:scale-100 opacity-0" : "opacity-0",
              ].join(" ")}
              style={{ animationDelay: visible ? "240ms" : undefined }}
            >
              <div className="text-center mb-5">
                <p
                  className={[
                    "text-brand-amber text-xs font-semibold uppercase tracking-wider mb-1 opacity-0",
                    visible ? "motion-reduce:opacity-100 animate-fade-in motion-reduce:animate-none" : "",
                  ].join(" ")}
                  style={{ animationDelay: visible ? "520ms" : undefined }}
                >
                  Instant &amp; online
                </p>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-0.5">Get a free quote</h2>
                <p className="text-gradient-brand font-semibold text-sm">Shyam Advertising</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <input
                    type="text"
                    placeholder="Your name"
                    required
                    className="w-full bg-black/60 border border-white/10 rounded-lg px-3 py-2.5 text-white placeholder-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-brand-amber/50 focus:border-brand-amber/40 transition-all"
                  />
                  <input
                    type="tel"
                    placeholder="Phone number"
                    required
                    className="w-full bg-black/60 border border-white/10 rounded-lg px-3 py-2.5 text-white placeholder-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-brand-amber/50 focus:border-brand-amber/40 transition-all"
                  />
                </div>

                <select 
                  required
                  className="w-full bg-black/60 border border-white/10 rounded-lg px-3 py-2.5 text-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-brand-amber/50 focus:border-brand-amber/40 transition-all"
                >
                  <option value="">Select a service</option>
                  {services.map((service) => (
                    <option key={service.id} value={service.name}>
                      {service.name}
                    </option>
                  ))}
                </select>

                <textarea
                  placeholder="Project details..."
                  rows={3}
                  required
                  className="w-full bg-black/60 border border-white/10 rounded-lg px-3 py-2.5 text-white placeholder-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-brand-amber/50 focus:border-brand-amber/40 transition-all resize-y min-h-[72px]"
                />

                <div className="border border-dashed border-brand-amber/35 rounded-xl p-4 text-center cursor-pointer hover:border-brand-yellow/60 hover:bg-brand-orange/5 transition-all bg-black/30">
                  <p className="text-gray-400 text-xs">
                    <span className="text-brand-amber font-medium">Attach files</span> — images, PDF, CDR
                    (max 10MB)
                  </p>
                  <input type="file" className="hidden" multiple accept="image/*,.pdf,.cdr" />
                </div>

                <button
                  type="submit"
                  className="w-full rounded-full bg-gradient-brand py-3 font-bold text-black text-sm hover:opacity-95 transition-all shadow-lg shadow-brand-orange/25 hover:shadow-[0_8px_28px_-4px_rgba(234,88,12,0.5)] active:scale-[0.99]"
                >
                  Send request
                </button>
              </form>

            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default Inquiry;

